"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToggleButtonDefaultProps = exports.ToggleButton = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _uuid = _interopRequireDefault(require("uuid"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ToggleButton = function ToggleButton(_ref) {
  var _classNamefn;

  var value = _ref.value,
      labelFloat = _ref.labelFloat,
      classNames = _ref.classNames,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      label = _ref.label,
      defaultChecked = _ref.defaultChecked,
      NewProps = _objectWithoutProperties(_ref, ["value", "labelFloat", "classNames", "onClick", "disabled", "label", "defaultChecked"]);

  var _useState = (0, _react.useState)(value || defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _uuid.default)()),
      _useState4 = _slicedToArray(_useState3, 1),
      InputID = _useState4[0]; // uuid was changing every re-render so storing once.


  (0, _react.useEffect)(function () {
    if (!_lodash.default.isUndefined(value)) setChecked(value);
  }, [value]);
  var toggleButtonClassName = (0, _classnames.default)((_classNamefn = {
    'togglebutton-component': true
  }, _defineProperty(_classNamefn, "togglebutton-component-label".concat(labelFloat), true), _defineProperty(_classNamefn, 'togglebutton-component__disabled', disabled), _classNamefn), [classNames]);
  var buttonBackgroundClassNames = (0, _classnames.default)({
    'togglebutton-component-button': true,
    'togglebutton-component--disabled-selected': value && disabled
  }, [classNames]);

  var handleClick = function handleClick(event) {
    event.stopPropagation();

    if (!disabled && value === undefined) {
      setChecked(!checked);
    } else if (!disabled && value !== undefined) {
      setChecked(value);
    }

    if (!disabled && typeof onClick !== 'undefined') {
      onClick(!checked);
    }
  }; // ADA compliant - allow an enter key to act like a click.


  var handleKeyPress = function handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, NewProps, {
    className: toggleButtonClassName,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    tabIndex: 0,
    role: "button"
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    className: 'togglebutton-component-label',
    htmlFor: InputID
  }, label), /*#__PURE__*/_react.default.createElement("input", {
    className: 'togglebutton-component-input',
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    id: InputID,
    readOnly: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: buttonBackgroundClassNames
  }));
};

exports.ToggleButton = ToggleButton;
ToggleButton.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  labelFloat: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']).isRequired,
  defaultChecked: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  value: _propTypes.default.bool,
  classNames: _propTypes.default.any,
  label: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.string])
};
var ToggleButtonDefaultProps = {
  disabled: false,
  labelFloat: 'left',
  defaultChecked: false
};
exports.ToggleButtonDefaultProps = ToggleButtonDefaultProps;
ToggleButton.defaultProps = ToggleButtonDefaultProps;
var _default = ToggleButton;
exports.default = _default;